import { render, staticRenderFns } from "./ManualTabs.vue?vue&type=template&id=4b0157d4"
import script from "./ManualTabs.vue?vue&type=script&lang=js"
export * from "./ManualTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports